"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BooleanFilterUI = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponentComponent = _interopRequireDefault(require("react-component-component"));

var _lodash = require("lodash");

var _utils = require("../utils");

var _api = _interopRequireDefault(require("../../utils/api"));

var _config = require("../../utils/config");

var _BooleanAgg = _interopRequireDefault(require("../../Aggs/BooleanAgg"));

var _common = require("./common");

require("./FilterContainerStyle.css");

var _Query = _interopRequireDefault(require("../../Query"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getFieldDisplayName = function getFieldDisplayName(fieldDisplayNameMap, initialFieldSqon) {
  return fieldDisplayNameMap[initialFieldSqon.content.field] || initialFieldSqon.content.field;
};

var AggsWrapper = function AggsWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "aggregation-card"
  }, children);
};

var BooleanFilterUI = function BooleanFilterUI(props) {
  var _props$onSubmit = props.onSubmit,
      onSubmit = _props$onSubmit === void 0 ? function (sqon) {} : _props$onSubmit,
      _props$onCancel = props.onCancel,
      onCancel = _props$onCancel === void 0 ? function () {} : _props$onCancel,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? _common.FilterContainer : _props$ContainerCompo,
      _props$sqonPath = props.sqonPath,
      sqonPath = _props$sqonPath === void 0 ? [] : _props$sqonPath,
      _props$initialSqon = props.initialSqon,
      initialSqon = _props$initialSqon === void 0 ? {} : _props$initialSqon,
      field = props.field,
      _props$fieldDisplayNa = props.fieldDisplayNameMap,
      fieldDisplayNameMap = _props$fieldDisplayNa === void 0 ? {} : _props$fieldDisplayNa,
      _props$buckets = props.buckets,
      buckets = _props$buckets === void 0 ? [] : _props$buckets;
  var initialState = {
    localSqon: initialSqon
  };
  var initialFieldSqon = (0, _utils.getOperationAtPath)(sqonPath)(initialSqon) || {
    op: _utils.IN_OP,
    content: {
      field: field,
      value: []
    }
  };

  var onSqonSubmit = function onSqonSubmit(s) {
    return function () {
      return onSubmit(s.state.localSqon);
    };
  };

  var onSelectionChange = function onSelectionChange(s) {
    return function (_ref2) {
      var value = _ref2.value;
      setTimeout(function () {
        var newOp = {
          op: _utils.IN_OP,
          content: {
            field: field,
            value: [value.key_as_string]
          }
        };
        s.setState({
          localSqon: (0, _utils.setSqonAtPath)(sqonPath, newOp)(s.state.localSqon)
        });
      }, 0);
    };
  };

  var isActive = function isActive(s) {
    return function (_ref3) {
      var value = _ref3.value;
      var op = (0, _utils.getOperationAtPath)(sqonPath)(s.state.localSqon);
      return value === (op && op.content.value[0]);
    };
  };

  var fieldDisplayName = getFieldDisplayName(fieldDisplayNameMap, initialFieldSqon);
  return /*#__PURE__*/_react["default"].createElement(_reactComponentComponent["default"], {
    initialState: initialState
  }, function (s) {
    return /*#__PURE__*/_react["default"].createElement(ContainerComponent, {
      onSubmit: onSqonSubmit(s),
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      key: "header",
      className: "contentSection headerContainer"
    }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(fieldDisplayName, "?"))), /*#__PURE__*/_react["default"].createElement("div", {
      key: "body",
      className: "contentSection bodyContainer"
    }, /*#__PURE__*/_react["default"].createElement(_BooleanAgg["default"], {
      WrapperComponent: AggsWrapper,
      field: initialFieldSqon.content.field,
      displayName: fieldDisplayName,
      buckets: buckets,
      defaultDisplayKeys: {
        "true": 'Yes',
        "false": 'No'
      },
      handleValueClick: onSelectionChange(s),
      isActive: isActive(s)
    }))));
  });
};

exports.BooleanFilterUI = BooleanFilterUI;
BooleanFilterUI.propTypes = {
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  ContainerComponent: _propTypes["default"].func,
  sqonPath: _propTypes["default"].array,
  initialSqon: _propTypes["default"].object,
  field: _propTypes["default"].string.isRequired,
  fieldDisplayNameMap: _propTypes["default"].object,
  buckets: _propTypes["default"].array
};

var _default = function _default(props) {
  var _props$api = props.api,
      api = _props$api === void 0 ? _api["default"] : _props$api,
      _props$arrangerProjec = props.arrangerProjectId,
      arrangerProjectId = _props$arrangerProjec === void 0 ? _config.PROJECT_ID : _props$arrangerProjec,
      arrangerProjectIndex = props.arrangerProjectIndex,
      initialSqon = props.initialSqon,
      executableSqon = props.executableSqon,
      sqonPath = props.sqonPath,
      field = props.field,
      onSubmit = props.onSubmit,
      onCancel = props.onCancel,
      fieldDisplayNameMap = props.fieldDisplayNameMap,
      opDisplayNameMap = props.opDisplayNameMap,
      _ContainerComponent = props.ContainerComponent;
  var gqlField = field.split('.').join('__');
  var query = "query($sqon: JSON){\n    ".concat(arrangerProjectIndex, " {\n      aggregations(filters: $sqon) {\n        ").concat(gqlField, " {\n          buckets {\n            key\n            key_as_string\n            doc_count\n          }\n        }\n      }\n    }\n  }");
  return /*#__PURE__*/_react["default"].createElement(_Query["default"], {
    api: api,
    projectId: arrangerProjectId,
    query: query,
    variables: {
      sqon: executableSqon
    },
    render: function render(_ref4) {
      var data = _ref4.data,
          loading = _ref4.loading,
          error = _ref4.error;
      return /*#__PURE__*/_react["default"].createElement(BooleanFilterUI, {
        ContainerComponent: function ContainerComponent(_ref5) {
          var children = _ref5.children,
              props = _objectWithoutProperties(_ref5, ["children"]);

          return /*#__PURE__*/_react["default"].createElement(_ContainerComponent, _extends({}, props, {
            loading: loading
          }), children);
        },
        field: field,
        initialSqon: initialSqon,
        onSubmit: onSubmit,
        onCancel: onCancel,
        sqonPath: sqonPath,
        fieldDisplayNameMap: fieldDisplayNameMap,
        opDisplayNameMap: opDisplayNameMap,
        buckets: data ? (0, _lodash.get)(data, "".concat(arrangerProjectIndex, ".aggregations.").concat(gqlField, ".buckets")) : []
      });
    }
  });
};

exports["default"] = _default;